import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { getQaSelector } from '../../../../../utils/common'
import { preventDefault, stopPropagation } from '../../../../../utils/events'
import Button from '../../../../Button'
import { FloatingTooltip } from '../../../../Floating'
import {
  ICON_COLOR,
  ICON_HEIGHT_16,
  IconNG,
  IconSpinnerOverlay,
} from '../../../../Icon'

import * as styles from './RequestProfileTabActivitiesPhaseHeaderMetaItem.module.css'

function RequestProfileTabActivitiesPhaseHeaderMetaItem({
  Icon,
  children,
  className = styles.RequestProfileTabActivitiesPhaseHeaderMetaItem,
  interactive,
  isLoading,
  qaName,
  tooltipKey,
  onClick,
}) {
  const { t } = useTranslation()

  function handleClick(event) {
    stopPropagation(event)
    preventDefault(event)
    onClick?.(event)
  }

  const qaProps = qaName ? getQaSelector({ value: qaName }) : undefined

  const tooltipContent = tooltipKey ? t(tooltipKey) : undefined

  const content = isLoading ? (
    <IconSpinnerOverlay size={ICON_HEIGHT_16} />
  ) : (
    <>
      {Icon ? (
        <IconNG
          Icon={Icon}
          color={ICON_COLOR.CurrentColor}
          size={ICON_HEIGHT_16}
        />
      ) : null}
      {children}
    </>
  )

  return interactive ? (
    <Button.Text
      {...qaProps}
      isGrey
      className={classNames(className, styles.interactive)}
      disabled={isLoading}
      tooltip={tooltipContent}
      onClick={handleClick}
    >
      {content}
    </Button.Text>
  ) : (
    <FloatingTooltip content={tooltipContent} disabled={!tooltipContent}>
      <div {...qaProps} className={className}>
        {content}
      </div>
    </FloatingTooltip>
  )
}

export default RequestProfileTabActivitiesPhaseHeaderMetaItem
